import { t } from 'ember-intl';
import { PhFilePdf, PhWarning } from 'ember-phosphor-icons';
import type { TOC } from '@ember/component/template-only';

interface AcceptedBannerSignature {
  Args: {
    filename: string;
  };
  Element: HTMLDivElement;
}

const AcceptedBanner: TOC<AcceptedBannerSignature> = <template>
  <div
    class="app-banner-strip app-banner-strip--warning"
    role="status"
    data-test-accepted-banner
    ...attributes
  >
    <PhWarning @size="18" @weight="fill" class="mt-0.5 shrink-0 app-icon-warning" />
    <div class="flex min-w-0 flex-1 flex-wrap items-center gap-1.5 text-sm">
      <PhFilePdf @size="14" class="shrink-0" />
      <span class="truncate font-medium app-status-text-warning">{{@filename}}</span>
      <span>
        {{t "tas.attachments.accepted_warning"}}
      </span>
    </div>
  </div>
</template>;

export default AcceptedBanner;
